let hls = null

const setHls = (value) => {
    hls = value
}

export {
    hls,
    setHls
}